import { useContext } from 'react';

import {
  type PaginationParams,
  type PaginationID,
} from '../../providers/Pagination/pagination.types'
import { PaginationContext } from '../../providers/Pagination/PaginationProvider'

export interface UsePaginationResults {
  state: {
    numPages: number
  }

  params: PaginationParams

  hasNextPage: boolean
  hasPreviousPage: boolean

  updatePage: (page: number) => void
  updatePageSize: (pageSize: number) => void
  updateNumPages: (numPages: number) => void
  updateSearch: (search: string) => void
  updateOrderBy: (orderBy: string) => void
  updateParams: (params: Partial<PaginationParams>) => void

  reset: () => void
}

type UsePaginationOptions = {
  id: PaginationID
}

/**
 * TODO:
 * Add support for pagination persistence through
 * refreshes and navigation.
 */

export const usePagination = ({
  id,
}: UsePaginationOptions): UsePaginationResults => {
  const {
    updateNumPages: updateNumPagesById,
    updateOrderBy: updateOrderByById,
    updatePage: updatePageById,
    updatePageSize: updatePageSizeById,
    updateParams: updateParamsById,
    updateSearch: updateSearchById,
    reset: resetById,
    getPaginationParamsById,
    getPaginationStateById,
  } = useContext(PaginationContext)

  const updateNumPages = (numPages: number) => {
    updateNumPagesById(id, numPages)
  }

  const updatePage = (page: number) => {
    updatePageById(id, page)
  }
  const updatePageSize = (pageSize: number) => {
    updatePageSizeById(id, pageSize)
  }

  const updateSearch = (search: string) => {
    updateSearchById(id, search)
  }

  const updateOrderBy = (orderBy: string) => {
    updateOrderByById(id, orderBy)
  }

  const updateParams = (params: Partial<PaginationParams>) => {
    updateParamsById(id, params)
  }

  const reset = () => {
    resetById(id)
  }

  const paginationParams = getPaginationParamsById(id)
  const paginationState = getPaginationStateById(id)

  const hasNextPage = (paginationParams.page || 1) < paginationState.numPages
  const hasPreviousPage = (paginationParams.page || 1) > 1

  return {
    state: paginationState,
    params: paginationParams,

    hasNextPage,
    hasPreviousPage,

    updateNumPages,
    updatePage,
    updatePageSize,
    updateSearch,
    updateOrderBy,
    updateParams,
    reset,
  }
}
